import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import PosSessionForm from '@pos/components/forms/pos-session-form/pos-session-form.vue';

@Component({
  name: 'bpc-resume-pos-session-drawer',
  components: {
    'bpc-drawer-modal': DrawerModal,
    'bpc-pos-session-form': PosSessionForm,
  },
})
export default class ResumePosSessionDrawerMethods extends Vue {
  showResumePosSessionDrawer: boolean = false;
  keyResumePosSessionForm: number = 1;
  resumePosSessionFormModelLoaded: boolean = false;

  onClickResumeSession(): void {
    this.resumePosSessionFormModelLoaded = false;
    this.keyResumePosSessionForm++;
    this.showResumePosSessionDrawer = true;
  }

  onFormCloseResumeSession(): void {
    this.showResumePosSessionDrawer = false;
  }

  onResumePosSessionFormModelLoaded(event) {
    this.resumePosSessionFormModelLoaded = true;
  }
  get showResumeSessionDrawer(): boolean {
    return this.$store.getters['pos/showResumeSessionDrawer'];
  }

  toggleResumeSessionDrawer() {
    this.$store.commit('pos/toggleResumeSessionDrawer');
    this.$store.commit('pos/toggleModalsOpened');
  }

  @Watch('showResumeSessionDrawer')
  onShowResumeSessionDrawer() {
    if (this.showResumeSessionDrawer === true) {
      this.keyResumePosSessionForm++;
    }
  }
}
